import { StoreData } from "modules/main/types/storeData";

type StoreBdData = {
    logo_url:string,
    name:string,
    normalized_name:string,
    checkout_url:string
}
    
export const getStoreBdData = (id:number, storeList:Array<StoreData>):StoreBdData => {
    const store_record =  storeList.find(store => store.id === id);        

    return ({
        logo_url:store_record?.logo_url??"",
        name:store_record?.name??"",
        normalized_name:store_record?.normalized_name??"",
        checkout_url:store_record?.checkout_url??""
    });
}   


export const getLogoMembership = (storeList:Array<StoreData>,store_id:number,text_key:string):string => {
    const store = storeList.find(store => store.id === store_id);
    if(!store){
        return "";
    }
    const membership = store.memberships.find(membership => membership.text_key === text_key);
    return membership?membership.logo_url:"";
}

export type {StoreBdData};